module.exports = __webpack_public_path__ + "static/media/dec-tutorial-passport.41cdae5c.gif";